/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
import { List$1 } from "./List$1";
import { Transaction } from "./Transaction";
/**
 * @hidden
 */
var TransactionHistory = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TransactionHistory, _super);
    function TransactionHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = new List$1(Transaction.$, 0);
        return _this;
    }
    Object.defineProperty(TransactionHistory.prototype, "transactions", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    TransactionHistory.$t = markType(TransactionHistory, 'TransactionHistory');
    return TransactionHistory;
}(Base));
export { TransactionHistory };
//# sourceMappingURL=TransactionHistory.js.map
